import request from './'

export const getPhoto = (id) => {
  return request({
    method: 'GET',
    url: `/api/boomerang/photos/${id}`
  })
}

export const getPhotos = ({ ownerId }) => {
  return request({
    method: 'GET',
    url: '/api/boomerang/photos',
    params: {
      filter: {
        owner_id: ownerId
      }
    }
  })
}
